import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import React, { useState, useCallback } from "react";

import { Scl90Update } from "./Scl90Update";
import { Scl90Delete } from "./Scl90Delete";

import Scl90Questions from "./Scl90Questions";
import { RadioQuestion } from "./Scl90RadioQuestion";

export function Scl90Edit(props) {
  const { scl90 } = useLoaderData();
  const navigate = useNavigate();
  let { tratamientoId, pacienteId } = useParams();
  let scl90Id = scl90.id;
  const errorMessage = scl90.message;

  // **Estados para el Modal de Error al no responder a las preguntas**
  const [scl90ErrorMessage, setScl90ErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [responses, setResponses] = useState({
    scl90Resp: scl90.meta?.scl90Resp || "",
    metaFecha: scl90.meta?.metaFecha || "",
    scl90Preg001: scl90.meta?.scl90Preg001 || "",
    scl90Preg002: scl90.meta?.scl90Preg002 || "",
    scl90Preg003: scl90.meta?.scl90Preg003 || "",
    scl90Preg004: scl90.meta?.scl90Preg004 || "",
    scl90Preg005: scl90.meta?.scl90Preg005 || "",
    scl90Preg006: scl90.meta?.scl90Preg006 || "",
    scl90Preg007: scl90.meta?.scl90Preg007 || "",
    scl90Preg008: scl90.meta?.scl90Preg008 || "",
    scl90Preg009: scl90.meta?.scl90Preg009 || "",
    scl90Preg010: scl90.meta?.scl90Preg010 || "",
    scl90Preg011: scl90.meta?.scl90Preg011 || "",
    scl90Preg012: scl90.meta?.scl90Preg012 || "",
    scl90Preg013: scl90.meta?.scl90Preg013 || "",
    scl90Preg014: scl90.meta?.scl90Preg014 || "",
    scl90Preg015: scl90.meta?.scl90Preg015 || "",
    scl90Preg016: scl90.meta?.scl90Preg016 || "",
    scl90Preg017: scl90.meta?.scl90Preg017 || "",
    scl90Preg018: scl90.meta?.scl90Preg018 || "",
    scl90Preg019: scl90.meta?.scl90Preg019 || "",
    scl90Preg020: scl90.meta?.scl90Preg020 || "",
    scl90Preg021: scl90.meta?.scl90Preg021 || "",
    scl90Preg022: scl90.meta?.scl90Preg022 || "",
    scl90Preg023: scl90.meta?.scl90Preg023 || "",
    scl90Preg024: scl90.meta?.scl90Preg024 || "",
    scl90Preg025: scl90.meta?.scl90Preg025 || "",
    scl90Preg026: scl90.meta?.scl90Preg026 || "",
    scl90Preg027: scl90.meta?.scl90Preg027 || "",
    scl90Preg028: scl90.meta?.scl90Preg028 || "",
    scl90Preg029: scl90.meta?.scl90Preg029 || "",
    scl90Preg030: scl90.meta?.scl90Preg030 || "",
    scl90Preg031: scl90.meta?.scl90Preg031 || "",
    scl90Preg032: scl90.meta?.scl90Preg032 || "",
    scl90Preg033: scl90.meta?.scl90Preg033 || "",
    scl90Preg034: scl90.meta?.scl90Preg034 || "",
    scl90Preg035: scl90.meta?.scl90Preg035 || "",
    scl90Preg036: scl90.meta?.scl90Preg036 || "",
    scl90Preg037: scl90.meta?.scl90Preg037 || "",
    scl90Preg038: scl90.meta?.scl90Preg038 || "",
    scl90Preg039: scl90.meta?.scl90Preg039 || "",
    scl90Preg040: scl90.meta?.scl90Preg040 || "",
    scl90Preg041: scl90.meta?.scl90Preg041 || "",
    scl90Preg042: scl90.meta?.scl90Preg042 || "",
    scl90Preg043: scl90.meta?.scl90Preg043 || "",
    scl90Preg044: scl90.meta?.scl90Preg044 || "",
    scl90Preg045: scl90.meta?.scl90Preg045 || "",
    scl90Preg046: scl90.meta?.scl90Preg046 || "",
    scl90Preg047: scl90.meta?.scl90Preg047 || "",
    scl90Preg048: scl90.meta?.scl90Preg048 || "",
    scl90Preg049: scl90.meta?.scl90Preg049 || "",
    scl90Preg050: scl90.meta?.scl90Preg050 || "",
    scl90Preg051: scl90.meta?.scl90Preg051 || "",
    scl90Preg052: scl90.meta?.scl90Preg052 || "",
    scl90Preg053: scl90.meta?.scl90Preg053 || "",
    scl90Preg054: scl90.meta?.scl90Preg054 || "",
    scl90Preg055: scl90.meta?.scl90Preg055 || "",
    scl90Preg056: scl90.meta?.scl90Preg056 || "",
    scl90Preg057: scl90.meta?.scl90Preg057 || "",
    scl90Preg058: scl90.meta?.scl90Preg058 || "",
    scl90Preg059: scl90.meta?.scl90Preg059 || "",
    scl90Preg060: scl90.meta?.scl90Preg060 || "",
    scl90Preg061: scl90.meta?.scl90Preg061 || "",
    scl90Preg062: scl90.meta?.scl90Preg062 || "",
    scl90Preg063: scl90.meta?.scl90Preg063 || "",
    scl90Preg064: scl90.meta?.scl90Preg064 || "",
    scl90Preg065: scl90.meta?.scl90Preg065 || "",
    scl90Preg066: scl90.meta?.scl90Preg066 || "",
    scl90Preg067: scl90.meta?.scl90Preg067 || "",
    scl90Preg068: scl90.meta?.scl90Preg068 || "",
    scl90Preg069: scl90.meta?.scl90Preg069 || "",
    scl90Preg070: scl90.meta?.scl90Preg070 || "",
    scl90Preg071: scl90.meta?.scl90Preg071 || "",
    scl90Preg072: scl90.meta?.scl90Preg072 || "",
    scl90Preg073: scl90.meta?.scl90Preg073 || "",
    scl90Preg074: scl90.meta?.scl90Preg074 || "",
    scl90Preg075: scl90.meta?.scl90Preg075 || "",
    scl90Preg076: scl90.meta?.scl90Preg076 || "",
    scl90Preg077: scl90.meta?.scl90Preg077 || "",
    scl90Preg078: scl90.meta?.scl90Preg078 || "",
    scl90Preg079: scl90.meta?.scl90Preg079 || "",
    scl90Preg080: scl90.meta?.scl90Preg080 || "",
    scl90Preg081: scl90.meta?.scl90Preg081 || "",
    scl90Preg082: scl90.meta?.scl90Preg082 || "",
    scl90Preg083: scl90.meta?.scl90Preg083 || "",
    scl90Preg084: scl90.meta?.scl90Preg084 || "",
    scl90Preg085: scl90.meta?.scl90Preg085 || "",
    scl90Preg086: scl90.meta?.scl90Preg086 || "",
    scl90Preg087: scl90.meta?.scl90Preg087 || "",
    scl90Preg088: scl90.meta?.scl90Preg088 || "",
    scl90Preg089: scl90.meta?.scl90Preg089 || "",
    scl90Preg090: scl90.meta?.scl90Preg090 || "",
  });

  // Calcular la diferencia en horas entre la fecha actual y la fecha de scl90
  const scl90Date = new Date(scl90.date);
  const diffDate = Math.abs(new Date() - scl90Date) / 36e5;

  const submitScl90 = async (e) => {
    e.preventDefault();
    setScl90ErrorMessage("");
    setIsErrorModalOpen(false);
    setIsCreatingButton(true);
    try {
      // Calcular el total de preguntas
      const totalQuestions = Scl90Questions.length;

      // Contar cuántas preguntas han sido respondidas
      const answeredQuestions = Scl90Questions.filter(
        (question) =>
          responses[question.id] && responses[question.id].trim() !== ""
      ).length;

      // Calcular el porcentaje de respuestas completadas
      const percentage = (answeredQuestions / totalQuestions) * 100;

      if (percentage < 100) {
        setScl90ErrorMessage(
          "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas."
        );
        setIsErrorModalOpen(true);
        setIsCreatingButton(false);
        return; // Evitar el envío del formulario
      }

      await Scl90Update(
        responses.scl90Resp,
        responses.metaFecha,
        responses.scl90Preg001,
        responses.scl90Preg002,
        responses.scl90Preg003,
        responses.scl90Preg004,
        responses.scl90Preg005,
        responses.scl90Preg006,
        responses.scl90Preg007,
        responses.scl90Preg008,
        responses.scl90Preg009,
        responses.scl90Preg010,
        responses.scl90Preg011,
        responses.scl90Preg012,
        responses.scl90Preg013,
        responses.scl90Preg014,
        responses.scl90Preg015,
        responses.scl90Preg016,
        responses.scl90Preg017,
        responses.scl90Preg018,
        responses.scl90Preg019,
        responses.scl90Preg020,
        responses.scl90Preg021,
        responses.scl90Preg022,
        responses.scl90Preg023,
        responses.scl90Preg024,
        responses.scl90Preg025,
        responses.scl90Preg026,
        responses.scl90Preg027,
        responses.scl90Preg028,
        responses.scl90Preg029,
        responses.scl90Preg030,
        responses.scl90Preg031,
        responses.scl90Preg032,
        responses.scl90Preg033,
        responses.scl90Preg034,
        responses.scl90Preg035,
        responses.scl90Preg036,
        responses.scl90Preg037,
        responses.scl90Preg038,
        responses.scl90Preg039,
        responses.scl90Preg040,
        responses.scl90Preg041,
        responses.scl90Preg042,
        responses.scl90Preg043,
        responses.scl90Preg044,
        responses.scl90Preg045,
        responses.scl90Preg046,
        responses.scl90Preg047,
        responses.scl90Preg048,
        responses.scl90Preg049,
        responses.scl90Preg050,
        responses.scl90Preg051,
        responses.scl90Preg052,
        responses.scl90Preg053,
        responses.scl90Preg054,
        responses.scl90Preg055,
        responses.scl90Preg056,
        responses.scl90Preg057,
        responses.scl90Preg058,
        responses.scl90Preg059,
        responses.scl90Preg060,
        responses.scl90Preg061,
        responses.scl90Preg062,
        responses.scl90Preg063,
        responses.scl90Preg064,
        responses.scl90Preg065,
        responses.scl90Preg066,
        responses.scl90Preg067,
        responses.scl90Preg068,
        responses.scl90Preg069,
        responses.scl90Preg070,
        responses.scl90Preg071,
        responses.scl90Preg072,
        responses.scl90Preg073,
        responses.scl90Preg074,
        responses.scl90Preg075,
        responses.scl90Preg076,
        responses.scl90Preg077,
        responses.scl90Preg078,
        responses.scl90Preg079,
        responses.scl90Preg080,
        responses.scl90Preg081,
        responses.scl90Preg082,
        responses.scl90Preg083,
        responses.scl90Preg084,
        responses.scl90Preg085,
        responses.scl90Preg086,
        responses.scl90Preg087,
        responses.scl90Preg088,
        responses.scl90Preg089,
        responses.scl90Preg090,
        tratamientoId,
        pacienteId,
        scl90Id
      ).then(
        (val) => {
          navigate(`../${tratamientoId}/cuestionarios/scl-90/${scl90Id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await Scl90Delete(scl90Id).then(
        (val) => {
          window.location.replace("../");
          // console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleResponseChange = useCallback((e) => {
    const { name, value } = e.target;
    setResponses((prev) => {
      if (prev[name] === value) return prev;
      return { ...prev, [name]: value };
    });
  }, []);

  return (
    <>
      <div id="content">
        {/* Mostrar modal de error si no se han contestado el 95% de las preguntas */}
        {isErrorModalOpen && (
          <div className={`modal ${isErrorModalOpen ? "is-active" : ""}`}>
            <div
              className="modal-background"
              onClick={() => setIsErrorModalOpen(false)}
            ></div>
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Algo salió mal...</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={() => setIsErrorModalOpen(false)}
                ></button>
              </header>
              <section className="modal-card-body">{scl90ErrorMessage}</section>
              <footer className="modal-card-foot">
                <button
                  className="button is-danger"
                  onClick={() => setIsErrorModalOpen(false)}
                >
                  Cerrar
                </button>
              </footer>
            </div>
          </div>
        )}
        {scl90.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form
            id="formUpdatelement"
            className="newRadioButtons"
            onSubmit={submitScl90}
          >
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="scl90Resp">Responsable</label>
                  <div className="control">
                    <input
                      className="input"
                      id="scl90Resp"
                      required
                      type="text"
                      value={responses.scl90Resp}
                      onChange={handleResponseChange}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="metaFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="metaFecha"
                      required
                      type="date"
                      value={responses.metaFecha}
                      onChange={handleResponseChange}
                    />
                  </div>
                </div>
              </div>
              <h3>Cuestionario SCL-90-R</h3>
              <p>
                Ayúdanos a optimizar tu tratamiento y observa tu evolución.
                Completa el cuestionario y OBTÉN 15€ A CAMBIO.
              </p>
              <br></br>
              <p>
                A continuación, hay un listado de problemas que en ocasiones
                tienen las personas. Por favor, léelos cuidadosamente y marca el
                número que mejor describa HASTA QUÉ PUNTO TE HA AFECTADO ESE
                PROBLEMA DURANTE LOS ÚLTIMOS 30 DÍAS. No olvides que debes
                contestar todas las cuestiones planteadas.
              </p>
              <br></br>
              <div className="form-radio-container">
                <div className="grid--2-col">
                  <div className="radio-capt radio--5-col">
                    <p>Nada</p>
                    <p>Un poco</p>
                    <p>Moderadamente</p>
                    <p>Bastante</p>
                    <p>Mucho</p>
                  </div>
                </div>
                {Scl90Questions.map((Scl90Question) => (
                  <RadioQuestion
                    key={Scl90Question.id}
                    id={Scl90Question.id}
                    label={Scl90Question.label}
                    name={Scl90Question.id}
                    value={responses[Scl90Question.id]}
                    onChange={handleResponseChange}
                  />
                ))}
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/cuestionarios/scl-90/${scl90.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
